import { render, staticRenderFns } from "./scoring-cycle-list.vue?vue&type=template&id=080de45b&scoped=true&"
import script from "./scoring-cycle-list.vue?vue&type=script&lang=js&"
export * from "./scoring-cycle-list.vue?vue&type=script&lang=js&"
import style0 from "./scoring-cycle-list.vue?vue&type=style&index=0&id=080de45b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080de45b",
  null
  
)

export default component.exports